import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Icon, IconButton, ReverseScroll, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import EmojiOne from 'emojione';
import isEqual from 'lodash/isEqual';
import * as React from 'react';
import { PHONE_BASED_CHANNELS } from 'app/utils/channels';
import { ConversationSummaryByCsid } from 'components/conversation';
import { useCommandHandler } from 'utils/commands';
import { prepareOriginalEmailUrl } from '../../../app/utils/messages';
import AssistantSummary from '../containers/assistant-summary';
import OriginalEmailModal from '../containers/originalEmailModal';
import PrinterFriendly from '../containers/printerFriendly';
import { Typing } from './Typing';
import MessageEmail from './messages/MessageEmail';
import MessageEmailHTML from './messages/MessageEmailHTML';
import { MessageFacebook } from './messages/MessageFacebook';
import { MessageInstagram } from './messages/MessageInstagram';
import MessagePhone from './messages/MessagePhone';
import { MessageSms } from './messages/MessageSms';
import { MessageTwitter } from './messages/MessageTwitter';
import MessageVoicemail from './messages/MessageVoicemail';
import { MessageWhatsApp } from './messages/MessageWhatsApp';
import MessageWidgetChat from './messages/MessageWidgetChat';
import NewMessagesDevider from './messages/NewMessagesDevider';
import { SatisfactionMessage } from './messages/SatisfactionMessage';
import StatusAbandoned from './messages/StatusAbandoned';
import { StatusAutoReply } from './messages/StatusAutoReply';
import StatusClosed from './messages/StatusClosed';
import StatusIsForward from './messages/StatusIsForward';
import StatusTransferAnswered from './messages/StatusTransferAnswered';
import StatusTransferStarted from './messages/StatusTransferStarted';
import StatusTransferStatus from './messages/StatusTransferStatus';
import StatusUnassigned from './messages/StatusUnassigned';
import TextMessage from './messages/TextMessage';
import '../styles/messages.less';
EmojiOne.ascii = true;
const renderedMessageTypes = [
    'newMissedMessagesDevider',
    'conversation:add_message',
    'conversation:message_added',
    'conversation:wrapup_message',
    'conversation:wrapup_added',
    'conversation:closed',
    'conversation:agent_unassigned',
    'conversation:transfer_initiated',
    'conversation:transfer_status',
    'conversation:transfer_answered',
    'conversation:rating_scheduled',
    'conversation:rating_unscheduled',
    'conversation:rating_offered',
    'conversation:rating_cancelled',
    'conversation:rated',
    'conversation:auto_reply_sent',
];
const includedInSummaryMessageTypes = [
    'conversation:message_added',
    'conversation:add_message',
];
export default class MessageSection extends React.Component {
    constructor(props) {
        super(props);
        this.scrollToBottom = () => {
            var _a;
            const { reverseScroll } = this.props;
            if (this.state.scrollAtBottom === true) {
                if (reverseScroll) {
                    (_a = this.reverseScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd();
                }
                else {
                    const divElm = this.wrapperRef.current;
                    if (divElm) {
                        divElm.scrollTop = divElm.scrollHeight;
                    }
                }
            }
        };
        this.onFetchPrinter = (url) => {
            this.props
                .originalEmailGetPrinterFriendly({ url: url })
                .then((response) => {
                var _a;
                // Currently prienter friendly markdown seems to be attached to response object.
                // So unless it is not defined use it, other than that
                // `contactform` conversation seem to return empty response for `originalEmailHtmlGetByType`
                const rewrittenHtml = ((_a = response.msg) === null || _a === void 0 ? void 0 : _a.rewritten_html) || response.rewritten_html;
                (rewrittenHtml
                    ? Promise.resolve(rewrittenHtml)
                    : this.props.originalEmailHtmlGetByType({
                        url: `${response.requestURL}`,
                        type: 'rewritten_html',
                    }))
                    .then((htmlResponse) => {
                    this.setState({ htmlIframeSrc: htmlResponse });
                    const myIframe = document.getElementById('printer-friendly');
                    if (!myIframe) {
                        console.warn('Failed to init print window.');
                        return;
                    }
                    this.timeouts.push(window.window.setTimeout(() => {
                        myIframe.contentWindow.print();
                    }, 1000));
                })
                    .catch((exception) => {
                    console.error('originalEmailHtmlGetByType exception', exception);
                });
            })
                .catch((exception) => {
                console.error('Exception', exception);
            });
        };
        this.timeouts = [];
        this.scrollToLastItemTimeout = null;
        this._closeAndScrollToNewMessage =
            this._closeAndScrollToNewMessage.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.getConversation = this.getConversation.bind(this);
        this.setSummary = this.setSummary.bind(this);
        this.state = {
            newMessagesContent: null,
            newMessagesClass: 'hidden',
            scrollAtBottom: true,
            isFirstPhoneMessage: false,
        };
        this.wrapperRef = React.createRef();
        this.messagesRef = React.createRef();
        this.reverseScrollRef = React.createRef();
    }
    componentWillUnmount() {
        if (this.timeouts !== null) {
            for (const timeout of this.timeouts) {
                window.clearTimeout(timeout);
            }
        }
        if (this.scrollToLastItemTimeout !== null) {
            window.clearTimeout(this.scrollToLastItemTimeout);
        }
    }
    componentDidMount() {
        this.scrollToLastItem();
        this.moveScrollToLastItemIfNeeded();
    }
    shouldComponentUpdate(nProps, nState) {
        return !isEqual(this.props, nProps) || !isEqual(this.state, nState);
    }
    componentDidUpdate(prevProps) {
        var _a;
        if (this.props.metaConversation.conversation.id !==
            prevProps.metaConversation.conversation.id) {
            this.setState({ scrollAtBottom: true });
            this.scrollToLastItem();
            this.moveScrollToLastItemIfNeeded();
        }
        if (!isEqual(this.props.metaConversation.conversation.summary, prevProps.metaConversation.conversation.summary)) {
            this.setSummary((_a = this.props.metaConversation.conversation.summary) === null || _a === void 0 ? void 0 : _a.current);
        }
        if (this.state.scrollAtBottom === true &&
            prevProps.messages.length < this.props.messages.length) {
            this.scrollToLastItem();
        }
        else if (this.state.scrollAtBottom === false &&
            prevProps.messages.filter(this.filterMessages).length <
                this.props.messages.filter(this.filterMessages).length) {
            this.setState({
                newMessagesClass: 'animationDown',
                newMessagesContent: (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: this._closeAndScrollToNewMessage, variant: "primary", type: "button", className: "new-message-button" }, { children: _jsxs("span", Object.assign({ className: "button-content" }, { children: [_jsx(Icon, { name: "arrow-down", className: "arrow-down" }), "New Message"] })) })), _jsx(IconButton, { type: "button", icon: "close", className: "close-new-messages", onClick: () => {
                                this.setState({
                                    newMessagesClass: 'animationUp',
                                    newMessagesContent: null,
                                });
                            } })] })),
            });
        }
    }
    /**
     * Checks if legacy components are used for redering email message and
     * scrolling and applies a dirty fix to move the scroll to the desired
     * location.
     *
     * When using iframe for rendering emails, the height of the message changes a
     * few times while loading. This causes a lot of changes in scrolling
     * position, which will result the scroll not staying in the desired location.
     * To fix this, we have to move the scroll to desired position after some
     * time. This is fine because the conversation takes long to load and it's not
     * like we move scroll long after the page is ready.
     *
     * This will be removed once both feature-flags are removed.
     */
    moveScrollToLastItemIfNeeded() {
        if ((!this.props.useShadowDom || !this.props.reverseScroll) &&
            this.props.metaConversation.conversation.initial_channel === 'email') {
            setTimeout(() => {
                this.scrollToLastItem();
            }, 1500);
        }
    }
    setSummary(summary = null) {
        this.props.conversationSetSummary(summary);
    }
    filterMessages(msg) {
        return msg.type === 'conversation:message_added';
    }
    isConversationPhoneCall(channel) {
        return PHONE_BASED_CHANNELS.includes(channel);
    }
    getAssistantMessages() {
        return this.props.messages.filter((message) => {
            return [
                'conversation:conversational_assistant_menu',
                'conversation:conversational_assistant_message',
                'conversation:conversational_assistant_input',
            ].includes(message.type);
        });
    }
    getRenderMessages() {
        return this.props.messages.filter((message) => {
            return renderedMessageTypes.includes(message.type);
        });
    }
    scrollToLastItem() {
        const { reverseScroll } = this.props;
        // Clear previous timeout to limit scroll occurrences
        if (this.scrollToLastItemTimeout !== null) {
            clearTimeout(this.scrollToLastItemTimeout);
            this.scrollToLastItemTimeout = null;
        }
        this.scrollToLastItemTimeout = window.setTimeout(() => {
            window.requestAnimationFrame(() => {
                var _a, _b;
                const scrollingOptions = {
                    // Use auto because smooth is too performance heavy
                    behavior: 'auto',
                    block: 'start',
                    inline: 'nearest',
                };
                if (reverseScroll) {
                    (_a = this.reverseScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToLastChild(scrollingOptions);
                }
                else if (this.messagesRef.current) {
                    (_b = this.messagesRef.current.children[this.messagesRef.current.children.length - 1]) === null || _b === void 0 ? void 0 : _b.scrollIntoView(scrollingOptions);
                }
            });
        }, 0);
    }
    onScrollHandler(e) {
        // Decide we should auto scroll to the bottom or not.
        const tolerance = 128;
        const isScrollAtBottom = this.props.reverseScroll
            ? Math.abs(e.target.scrollTop) < tolerance
            : e.target.scrollTop + e.target.offsetHeight >=
                e.target.scrollHeight - tolerance;
        if (isScrollAtBottom) {
            this.setState({
                scrollAtBottom: true,
                newMessagesClass: 'animationUp',
                newMessagesContent: null,
            });
        }
        else if (this.props.asyncStatus.getConversation === 'succeeded') {
            this.setState({ scrollAtBottom: false });
        }
    }
    _closeAndScrollToNewMessage() {
        var _a;
        this.setState({
            newMessagesClass: 'animationUp',
            newMessagesContent: null,
        });
        if (this.props.reverseScroll) {
            (_a = this.reverseScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd();
        }
        else {
            const divElm = this.wrapperRef.current;
            divElm.scrollTop = divElm.scrollHeight;
        }
    }
    getAuthorFromUser(user) {
        var _a, _b, _c;
        const initials = !user.avatar_url
            ? (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.name) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b.map((name) => name[0])) === null || _c === void 0 ? void 0 : _c.join('')
            : null;
        return {
            image: user.avatar_url || null,
            name: user.name,
            initials: initials,
            id: user.id,
        };
    }
    renderParentLink() {
        const { metaConversation: { parentConversation, conversation }, } = this.props;
        if (parentConversation && conversation.link_type === 'email_forward') {
            return (_jsx(StatusIsForward, { csid: parentConversation.id, className: this.getClassName('status') }));
        }
        return null;
    }
    getErrorReasonMessage(rawType, rawDescription) {
        const type = (rawType !== null && rawType !== void 0 ? rawType : '').replace('-', '_');
        const description = (rawDescription !== null && rawDescription !== void 0 ? rawDescription : '').replace('-', '_');
        switch (description) {
            // Mandrill-specific failures
            case 'spam_filter':
                return 'The receiver has marked the sending email address as spam. A spam complaint occurs when the recipient clicks the “report spam” button in their email client. The email could not be delivered. Try again in 24 hours.';
            case 'invalid_domain':
                return 'The email domain that you tried to reach does not exist. Delivery is not possible. Will not retry.';
            // Common failures
            case 'bad_mailbox':
                return 'Bad mailbox: One or more of the email addresses you are trying to reach does not exist. The message was therefore not sent. The system will not try to resend the message to that/those email addresses. To solve the issue please check the email address you are trying to reach and try resending it in a new message to the corrected email address.';
            case 'suppressed':
                return 'Suppressed: One or more of the email addresses you are trying to reach is blacklisted by our email provider and was therefore not sent. Please reach out to Dixa Support to resolve the issue.';
            case 'attachment_rejected':
                return "Attachment Rejected: One or more of the recipients' mail servers has rejected the message due to an unacceptable attachment format or the attachment is too large. To resolve this issue, please try again after removing or modifying the attachment(s).";
            case 'content_rejected':
                return "Content Rejected: One or more of the recipients' email servers has rejected the message based on the content of the message. To resolve this issue, please try again after removing or modifying the content of the message.";
            case 'message_too_large':
                return "Message too large: One or more of the recipients' email servers did not accept the message because the message content (text) is too big or long. To resolve this issue, please try again after reducing the size of the message.";
            case 'mailbox_full':
                return "Mailbox full: One or more of the recipients' mail servers is not accept the message because their mailbox is full and the message could not be delivered. The system will not automatically retry on these types of errors. Usually a succesful attempt can be made after 48 hours.";
            case 'rejected':
                return 'Rejected: The sending mail server has flagged the content of the message as malicious and was not send. The system will not automatically retry on these types of errors. Please modify the content of the message and try again.';
            default:
                switch (type) {
                    // Mandrill-specific failure types
                    case 'reject':
                        return 'Reject: The system has flagged the sending mail account of this message as blacklisted. The system will not automatically retry on these types of errors. Please reach out to Dixa Support to resolve the issue.';
                    case 'spam':
                        return "Spam: One or more of the recipients' mail servers did not accept the message because the sending email account has been marked as Spam. The system will not automatically retry on these types of errors. A spam complaint occurs when a recipient marks a message as spam in their email client. To resolve this please reach out on a different sending email.";
                    // Common failure types
                    case 'hard_bounce':
                        return "Hard bounce: One or more of the recipients' email servers rejected the message. The system will not automatically retry on these types of errors. To solve the issue please verify the recipient's email address is correct and try to send the message again. If problems persist, please reach out to Dixa Support.";
                    case 'soft_bounce':
                        return 'Soft bounce: One or more of the email addresses you are trying to reach is not accepting the message at this point. Please try again later - we recommend to wait 48 hours.';
                    case 'complaint':
                        return 'Complaint: The email was delivered but it was flagged as spam. Please avoid sending further messages to this email address to avoid degradation of your email (spam) reputation.';
                    default:
                        return 'Unknown error: In trying to send the message (one of) the recipient(s) responded with an error message not known to the Dixa platform and rejected the message. The system will not automatically retry on unknown errors. We recommend to try again later - wait at least 48 hours before retrying. If sending should still fail, please contact Dixa Support for further assistance.';
                }
        }
    }
    getConversationID() {
        return this.props.metaConversation.conversation.id;
    }
    getConversationChannel() {
        const channel = this.props.metaConversation.conversation.initial_channel;
        return typeof channel === 'string' ? channel : '';
    }
    getConversation() {
        if (this.getConversationID()) {
            this.props
                .conversationGet({
                csid: this.getConversationID(),
            })
                .catch((err) => {
                console.error('Caught', err);
                return err;
            });
        }
    }
    isLastMessageToIncludeInSummarization(message) {
        const { metaConversation: { messages }, } = this.props;
        const textualMessages = messages.filter((message) => includedInSummaryMessageTypes.includes(message.type));
        return (textualMessages.findIndex((currentMessage) => currentMessage.id === message.id) ===
            textualMessages.length - 1);
    }
    renderMessage(
    // Using type `Message` instead of any requires refactoring some other parts
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    message, messageIndex, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    allMessages) {
        var _a, _b, _c, _d, _e, _f;
        const { enableCallRecordings, metaConversation } = this.props;
        const { conversation } = metaConversation;
        const conversationChannel = this.getConversationChannel();
        const requesterId = conversation.requested_by;
        const internal = [
            'conversation:wrapup_message',
            'conversation:wrapup_added',
        ].includes(message.type);
        const own = message.author.id === this.props.thisUserId;
        const isAgent = message.author.id !== requesterId;
        const first = messageIndex === 0;
        const newest = messageIndex === allMessages.length - 1;
        const { email_send_error = '', email_send_error_description = '', email_send_error_smtp_response = '', } = message;
        const conversationAttributes = conversation.attributes;
        const isInstagram = message.channel === 'facebookmessenger' &&
            ((_a = conversation.attributes) === null || _a === void 0 ? void 0 : _a.instagram_page_id) &&
            ((_b = conversation.attributes) === null || _b === void 0 ? void 0 : _b.instagram_profile_id);
        const simple = isInstagram && message.is_story
            ? false
            : message.isSameSender && !internal;
        const messageProps = {
            conversationAttributes,
            simple,
            className: classnames({
                [this.getClassName('message')]: true,
                [this.getClassName('message--continued')]: simple,
                [this.getClassName('message--nofill')]: !own &&
                    !isAgent &&
                    !['pstnphone', 'pstn_phone', 'callback', 'voicemail'].includes(message.channel) &&
                    !internal,
            }),
            own,
            isAgent,
            newest,
            first,
            internal,
            catchInternalLinks: internal,
            date: message.created_at || Date.now() / 1000,
            message: message,
            author: message.author,
            key: message.id,
            loading: !message.hasReceivedResponse,
            failed: message.failedResponse || email_send_error
                ? this.getErrorReasonMessage(email_send_error, email_send_error_description)
                : false,
            failureReason: email_send_error_smtp_response,
            markup: null,
            isAutoReply: message.is_auto_reply,
            renderedTemplateName: message.rendered_template_name,
            conversation,
        };
        const statusProps = {
            message,
            key: message.id,
            className: this.getClassName('status'),
            date: message.created_at || Date.now() / 1000,
        };
        /* Messages */
        if (['conversation:add_message', 'conversation:message_added'].includes(message.type)) {
            let Component = null;
            if (['email', 'contactform', 'widgetchat', 'messenger'].includes(message.channel)) {
                // We need markup for these
                if (message.channel === 'email' || message.channel === 'contactform') {
                    messageProps.computedDeliveryEvent =
                        conversation.message_delivery_status
                            ? conversation.message_delivery_status[message.id]
                            : null;
                    messageProps.messageId = message.id;
                    messageProps.csid = conversation.id;
                    const orignalUrl = message.email_original_content_url;
                    if (orignalUrl && message.direction === 'inbound') {
                        // For fetching text/markdown email.
                        messageProps.originalEmailMeta = this.props.originalEmailMeta;
                        // For showing original email.
                        messageProps.onShowOriginal = () => {
                            this.props.originalEmailGet({
                                url: prepareOriginalEmailUrl(orignalUrl),
                            });
                        };
                        // For fetching HTML email.
                        messageProps.orignalUrl = prepareOriginalEmailUrl(orignalUrl);
                        messageProps.htmlMessages = this.props.htmlMessages;
                        messageProps.originalEmailGetHtmlMessage =
                            this.props.originalEmailGetHtmlMessage;
                        messageProps.keyIssue = (_d = (_c = conversation.attributes) === null || _c === void 0 ? void 0 : _c.keyIssue) !== null && _d !== void 0 ? _d : '';
                        messageProps.messageIntent =
                            (_f = (_e = conversation.attributes) === null || _e === void 0 ? void 0 : _e.messageIntent) !== null && _f !== void 0 ? _f : '';
                        // For showing printing email.
                        messageProps.onFetchPrinter = () => {
                            this.onFetchPrinter(prepareOriginalEmailUrl(orignalUrl));
                        };
                        // Switch here between HTML and text email. / MessageEmail
                        Component = MessageEmailHTML;
                    }
                    else {
                        Component = MessageEmail;
                    }
                }
                else {
                    Component = MessageWidgetChat;
                }
            }
            else if (['pstnphone', 'pstn_phone', 'callback'].includes(message.channel)) {
                // Add recording if allowed with the feature flag.
                if (enableCallRecordings) {
                    messageProps.recordingURL = message.recording_url;
                }
                Component = MessagePhone;
            }
            else if (message.channel === 'voicemail') {
                messageProps.recordingURL = message.voicemail_url;
                Component = MessageVoicemail;
            }
            else if (message.channel === 'whatsapp') {
                Component = MessageWhatsApp;
            }
            else if (isInstagram) {
                Component = MessageInstagram;
            }
            else if (message.channel === 'facebookmessenger') {
                Component = MessageFacebook;
            }
            else if (message.channel === 'sms') {
                Component = MessageSms;
            }
            else if (message.channel === 'twitter') {
                Component = MessageTwitter;
            }
            else {
                throw Error(`The message channel '${message.channel}' does not have an appropriate message component.`);
            }
            return _jsx(Component, Object.assign({}, messageProps, { author: message.author }));
        }
        if (internal) {
            // We need markup for these
            return _jsx(TextMessage, Object.assign({}, messageProps));
        }
        if ('conversation:closed' === message.type &&
            this.isConversationPhoneCall(conversationChannel)) {
            return _jsx(StatusClosed, Object.assign({}, statusProps, { own: messageProps.own }));
        }
        if ('conversation:agent_unassigned' === message.type &&
            this.isConversationPhoneCall(conversationChannel)) {
            return _jsx(StatusUnassigned, Object.assign({}, statusProps));
        }
        if ('newMissedMessagesDevider' === message.type) {
            return _jsx(NewMessagesDevider, Object.assign({}, statusProps)); // Revisit
        }
        if ('conversation:transfer_initiated' === message.type &&
            this.isConversationPhoneCall(conversationChannel)) {
            return _jsx(StatusTransferStarted, Object.assign({}, statusProps));
        }
        if ('conversation:transfer_status' === message.type &&
            this.isConversationPhoneCall(conversationChannel)) {
            return _jsx(StatusTransferStatus, Object.assign({}, statusProps));
        }
        if ('conversation:transfer_answered' === message.type &&
            this.isConversationPhoneCall(conversationChannel)) {
            return _jsx(StatusTransferAnswered, Object.assign({}, statusProps));
        }
        if ('conversation:rated' === message.type) {
            const ratingOffered = allMessages.find((message) => message.type === 'conversation:rating_offered');
            const style = (ratingOffered === null || ratingOffered === void 0 ? void 0 : ratingOffered.csat_look_and_feel)
                ? ratingOffered.csat_look_and_feel
                : 'numbers';
            return (_jsx(SatisfactionMessage, Object.assign({ ratingStyle: style, score: message.score, comment: message.comment }, statusProps)));
        }
        if ('conversation:auto_reply_sent' === message.type) {
            return (_jsx(StatusAutoReply, Object.assign({ templateName: message.template_name }, statusProps)));
        }
        return null;
    }
    renderMessagesAndSummary() {
        var _a, _b;
        const { metaConversation, reverseScroll } = this.props;
        const { conversation } = metaConversation;
        const summary = (_a = conversation.summary) === null || _a === void 0 ? void 0 : _a.current;
        const canGenerateSummary = !!((_b = conversation.summary) === null || _b === void 0 ? void 0 : _b.can_be_generated);
        const messages = this.getRenderMessages();
        if (!conversation.id || !messages.length) {
            return null;
        }
        // TODO [CONV-371]: remove
        const MessagesContainer = reverseScroll ? ReverseScroll : 'div';
        return (_jsxs(MessagesContainer, Object.assign({ ref: reverseScroll ? this.reverseScrollRef : this.messagesRef, className: this.getClassName('messages-list'), onScroll: this.onScrollHandler }, { children: [this.renderParentLink(), messages.map((message, index, messages) => {
                    const renderedMessage = this.renderMessage(message, index, messages);
                    if ((summary === null || summary === void 0 ? void 0 : summary.last_used_message_id) !== message.id) {
                        return renderedMessage;
                    }
                    // If there is summary having this message id as last message, render
                    // it right after the message so that it'll be sticky to the message.
                    return (_jsxs(_Fragment, { children: [renderedMessage, _jsx(ConversationSummaryByCsid, { className: this.getClassName('summary'), view: "details", csid: conversation.id, onSummaryLoaded: this.setSummary, initialSummary: summary, isStale: !this.isLastMessageToIncludeInSummarization(message) }, summary === null || summary === void 0 ? void 0 : summary.id)] }));
                }), canGenerateSummary && !summary && (
                // If there is new no summary, but it can be generated, render it in the end of the meesages.
                _jsx(ConversationSummaryByCsid, { className: this.getClassName('summary'), view: "details", csid: conversation.id, onSummaryLoaded: this.setSummary }, `csid-${conversation.id}-summary`))] })));
    }
    // TODO [CONV-371]: remove
    getClassName(className) {
        const { reverseScroll } = this.props;
        return reverseScroll
            ? `messages-reverse-scroll__${className}`
            : `messages__${className}`;
    }
    render() {
        let loading = null;
        let animationClass = 'hidden';
        const { metaConversation, asyncStatus, reverseScroll } = this.props;
        const { conversation } = metaConversation;
        const hasConversationID = !!this.getConversationID();
        /*
          Loading stuff: Can be moved to component
         */
        if (asyncStatus.getConversation === 'succeeded') {
            loading = null;
            animationClass = 'animationUp';
        }
        else if (asyncStatus.getConversation === 'loading' &&
            (!metaConversation || metaConversation.messages.length === 0)) {
            loading = _jsx("div", Object.assign({ className: "messages-notification" }, { children: "Loading..." }));
            animationClass = 'animationDown';
        }
        else if (asyncStatus.getConversation === 'failed') {
            loading = (_jsx("div", Object.assign({ className: "messages-notification" }, { children: hasConversationID ? (_jsx(Button, Object.assign({ variant: "primary", onClick: this.getConversation }, { children: "Error loading conversation - try again" }))) : (_jsx(Button, Object.assign({ variant: "primary" }, { children: "Error loading conversation" }))) })));
            animationClass = 'animationDown';
        }
        /** Typing indicator: Can be moved to component */
        const renderTyping = (typing, i) => {
            if (conversation.id === typing.csid) {
                return (_jsx(Typing, { authors: conversation.authors, typing: typing, onShow: this.scrollToBottom }, i));
            }
            return null;
        };
        return (_jsxs("div", Object.assign({ id: "messages", className: classnames({
                ['messages']: !reverseScroll,
                ['messages-reverse-scroll']: reverseScroll,
            }), ref: this.wrapperRef, onScroll: this.onScrollHandler, "aria-live": "polite", "aria-relevant": "additions", "aria-atomic": "false", role: "log" }, { children: [_jsx(MessageSectionCommandHandler, { wrapperRef: this.wrapperRef, reverseScrollRef: reverseScroll ? this.reverseScrollRef : undefined }), _jsx(AssistantSummary, { messages: this.getAssistantMessages() }), this.renderMessagesAndSummary(), conversation.is_abandoned && _jsx(StatusAbandoned, {}), this.props.typings.map(renderTyping), _jsx(OriginalEmailModal, {}), _jsx(PrinterFriendly, { htmlIframeSrc: this.state.htmlIframeSrc }), _jsx("div", Object.assign({ className: `text-center loading-content ${animationClass}` }, { children: loading })), _jsx("div", Object.assign({ className: `text-center new-messages-content ${this.state.newMessagesClass}` }, { children: this.state.newMessagesContent }))] }), conversation.id));
    }
}
const MessageSectionCommandHandler = ({ wrapperRef, reverseScrollRef, }) => {
    useCommandHandler({
        name: 'conversation:messagesScrollToTop',
        actionFn: () => {
            var _a;
            if (reverseScrollRef) {
                (_a = reverseScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToStart();
            }
            else if (wrapperRef.current) {
                // TODO [CONV-371]: remove
                wrapperRef.current.scrollTop = 0;
            }
        },
    });
    useCommandHandler({
        name: 'conversation:messagesScrollToBottom',
        actionFn: () => {
            var _a;
            if (reverseScrollRef) {
                (_a = reverseScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToEnd();
            }
            else if (wrapperRef.current) {
                // TODO [CONV-371]: remove
                wrapperRef.current.scrollTop = wrapperRef.current.scrollHeight;
            }
        },
    });
    return null;
};
